import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { IncomeSourcesManager } from '@/components/financial/income-sources-manager';

export const Route = createFileRoute('/income-sources')({
  component: IncomeSourcesPage,
});

function IncomeSourcesPage() {
  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        <div>
          <h1 className="font-bold text-2xl tracking-tight">
            Fontes de Renda
          </h1>
          <p className="text-muted-foreground">
            Gerencie suas fontes de renda e veja o total mensal líquido
          </p>
        </div>

        <IncomeSourcesManager />
      </div>
    </AuthGuard>
  );
}
